import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaHastaFormGroup = ({ fIsSubmitting, iError, iTouched }) => {
  return (
    <Form.Group>
      <Form.Label md={4} text='Hasta' alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaHasta'>
          {({ field }) => <Form.InputDate {...field} id='date-fechaHasta' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaHastaFormGroup)
